export default __webpack_public_path__ + "static/media/desktop-hero-english.03132d15.svg";